module.exports = __webpack_public_path__ + "img/third.ec02e86f.jpg";